import React, { Dispatch, SetStateAction } from 'react';

import { TableRow } from '@material-ui/core';
import { NoBorderCell } from 'components/common/table/TableStyle';
import DateRangePicker from 'components/common/searchfilter/contents/DateRangePicker';

import { BoldText } from '../ModalContent.styled';

interface Props {
  couponDateInterval: string[];
  setCouponDateInterval: Dispatch<SetStateAction<string[]>>;
}

const Date = ({ couponDateInterval, setCouponDateInterval }: Props) => {
  return (
    <TableRow>
      <NoBorderCell>
        <BoldText>Date</BoldText>
      </NoBorderCell>
      <NoBorderCell>
        <DateRangePicker
          dateInterval={couponDateInterval}
          setDateInterval={setCouponDateInterval}
          disableOnFrom
        />
      </NoBorderCell>
    </TableRow>
  );
};

export default Date;
